import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { AccountService } from '@services/account.service'
import { ReportService } from '@services/report.service'
import { Events } from '@services/events'
import { Subscription } from 'rxjs'
import { Account } from '@models/account.model'

@Component({
	selector: 'sbpro-top-nav-tenant-select',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './top-nav-tenant-select.component.html',
	styleUrls: ['top-nav-tenant-select.component.scss'],
	standalone: false
})
export class TopNavTenantSelectComponent implements OnInit, OnDestroy {
	@Input() searchable = false

	tenantLogoUrl = ''
	hasTenantLogo = false
	loadingLogo = false
	private tenantLogoObjectUrl?: string
	private lastRequestedTenantId?: string
	private subscription = new Subscription()

	constructor(
		public accountService: AccountService,
		private reportService: ReportService,
		private changeDetectorRef: ChangeDetectorRef,
		private events: Events
	) {}

	ngOnInit() {
		void this.loadTenantLogo()
		this.subscription.add(
			this.events.on<Account>('reloadMenu').subscribe(account => {
				const tenantId = account?.tenantId ?? this.accountService.tenantId
				void this.loadTenantLogo(tenantId)
			})
		)
		this.subscription.add(
			this.events.on<boolean>('tenantChanged').subscribe(() => {
				this.reportService.clearLogoCache()
				this.setDefaultLogo()
			})
		)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}

	private async loadTenantLogo(tenantId = this.accountService.tenantId) {
		if (!tenantId) {
			this.lastRequestedTenantId = undefined
			this.setDefaultLogo()
			return
		}

		if (this.lastRequestedTenantId === tenantId && this.tenantLogoUrl) {
			return
		}

		this.loadingLogo = true
		this.lastRequestedTenantId = tenantId
		try {
			const logoUrl = await this.reportService.logo(tenantId)
			if (this.lastRequestedTenantId !== tenantId) {
				return
			}
			this.setTenantLogo(logoUrl)
		} finally {
			this.loadingLogo = false
		}
	}

	private setTenantLogo(url: string) {
		if (url.includes('assets/img/logo-brand.png')) {
			this.setDefaultLogo()
			return
		}

		if (this.tenantLogoObjectUrl && this.tenantLogoObjectUrl !== url) {
			URL.revokeObjectURL(this.tenantLogoObjectUrl)
		}

		this.tenantLogoUrl = url
		this.tenantLogoObjectUrl = url.startsWith('blob:') ? url : undefined
		this.hasTenantLogo = true
		this.changeDetectorRef.markForCheck()
	}

	private setDefaultLogo() {
		if (this.tenantLogoObjectUrl) {
			URL.revokeObjectURL(this.tenantLogoObjectUrl)
		}

		this.tenantLogoObjectUrl = undefined
		this.tenantLogoUrl = ''
		this.hasTenantLogo = false
		this.changeDetectorRef.markForCheck()
	}
}
